module.exports = __webpack_public_path__ + "img/vezapodorysy3NP.8dec16b4.png";